import { AiOutlineArrowRight } from "react-icons/ai";

const RightArrowIcon = (props) => {
  return <AiOutlineArrowRight className={props.className} />;
};

export default RightArrowIcon;
